import { queryOptions, useQuery, useQueryClient } from '@tanstack/react-query'
import { authQueryOptions } from '../auth/queries'
import { getGameBlinds } from './api'

export const useGameBlindOptions = (accessToken: string) => {
  return queryOptions({
    queryKey: ['gameBlinds'],
    queryFn: () => getGameBlinds({ access_token: accessToken }),
  })
}

export function useGameBlindsQuery() {
  const queryClient = useQueryClient()
  const authData = queryClient.getQueryData(authQueryOptions('').queryKey)
  const accessToken = authData?.access_token

  return useQuery({
    ...useGameBlindOptions(accessToken ?? ''),
    enabled: !!accessToken,
  })
}
